import { c as _c } from "react/compiler-runtime";
import { Button, ButtonGroup, ButtonGroupProps, ButtonProps, Heading, HeadingProps, Stack, StackProps, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type RequestExampleCardProps = {
  title: string;
  tags: string[];
  investors: string[];
  noOfMatches: string;
  parentStackProps?: StackProps;
  statsStackProps?: StackProps;
  titleProps?: HeadingProps;
  tagButtonProps?: ButtonProps;
  buttonGroupProps?: ButtonGroupProps;
};
export const RequestExampleCard = props => {
  const $ = _c(32);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([4, 4, 6, 6, 6]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.parentStackProps;
  const t2 = isMobile ? "center" : "start";
  let t3;
  if ($[2] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 8, 8, 8]);
    $[2] = getBreakpointValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isMobile ? "center" : "start";
  let t5;
  if ($[4] !== getBreakpointValue) {
    t5 = getBreakpointValue(["lg", "xl", "2xl", "2xl", "2xl"]);
    $[4] = getBreakpointValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props.title || $[7] !== props.titleProps || $[8] !== t5) {
    t6 = <Heading size={t5} {...props.titleProps}>{props.title}</Heading>;
    $[6] = props.title;
    $[7] = props.titleProps;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = isMobile ? "center" : "start";
  const t8 = props.statsStackProps;
  const t9 = props.buttonGroupProps;
  let t10;
  if ($[10] !== props.tagButtonProps || $[11] !== props.tags) {
    let t11;
    if ($[13] !== props.tagButtonProps) {
      t11 = tag => <Button key={tag} bgColor={tag === "Funding" ? "teal.focusRing" : "blackAlpha.500"} color={tag === "Funding" ? "black" : "white"} {...props.tagButtonProps}>{tag}</Button>;
      $[13] = props.tagButtonProps;
      $[14] = t11;
    } else {
      t11 = $[14];
    }
    t10 = props.tags.map(t11);
    $[10] = props.tagButtonProps;
    $[11] = props.tags;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[15] !== props.buttonGroupProps || $[16] !== t10) {
    t11 = <ButtonGroup size="xs" {...t9}>{t10}</ButtonGroup>;
    $[15] = props.buttonGroupProps;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== props.statsStackProps || $[19] !== t11 || $[20] !== t7) {
    t12 = <Stack align="center" direction="row" gap={2} justify={t7} width="full" {...t8}>{t11}</Stack>;
    $[18] = props.statsStackProps;
    $[19] = t11;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t6) {
    t13 = <VStack align={t2} gap={t3} justify={t4} width="full">{t6}{t12}</VStack>;
    $[22] = t12;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== props.parentStackProps || $[29] !== t0 || $[30] !== t13) {
    t14 = <VStack align="start" background="actionActiveSecondary" borderRadius="xl" boxShadow="sm" direction="column" gap={0} justify="center" overflow="hidden" padding={t0} width="full" {...t1}>{t13}</VStack>;
    $[28] = props.parentStackProps;
    $[29] = t0;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};